import {
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eb/site-analytics';

import { parseFormPostData } from '../api/utils';
import { socialLogIn as socialLogInApi } from '../api';

import {
    GA_AUTH_CATEGORY,
    GA_SOCIAL_LOGIN_EVENT,
    GA_APPLE_LOGIN_ACCOUNT_CREATED,
    GA_APPLE_LOGIN_RETURNING_USER_LOGIN_SUCCESS,
    LOOKUP_SOCIAL_USER_EXISTENT,
} from '../constants';

import { APPLE_PROVIDER } from '../constants/newIndex';

import { trackLoginSuccessful } from './gaTracking';

import { getSocialLogInFormData } from './utils';

import { handleLoginSuccess } from './social';

import { lookupUser } from './lookup';

import {
    handleOnError,
    addSocialAuthenticationDataAction,
    setAccountExistent,
} from './auth';

export const handleAppleLoginAttempt = ({
    socialProvider,
    data,
    getState,
    dispatch,
}) => {
    const state = getState();
    const {
        authentication: {
            featureFlags: { launchAuthenticationRefactor },
        },
    } = state;

    if (launchAuthenticationRefactor) {
        const _data = getSocialLoginApiData({
            launchAuthenticationRefactor,
            socialProvider,
            data,
        });

        dispatch(
            addSocialAuthenticationDataAction({
                socialAuthenticationData: { [socialProvider]: _data },
            }),
        );

        return dispatch(
            lookupUser({ email: data.email, socialProvider }),
        ).catch(({ message }) => {
            if (message === LOOKUP_SOCIAL_USER_EXISTENT) {
                return handleAppleSocialLogin({
                    data: _data,
                    getState,
                    dispatch,
                    socialProvider,
                });
            }
        });
    } else {
        handleAppleSocialLogin({
            data,
            getState,
            dispatch,
            socialProvider,
        });
    }
};

export const handleAppleSocialLogin = ({
    data,
    getState,
    dispatch,
    socialProvider,
}) => {
    const state = getState();

    return socialLogInApi(
        parseFormPostData(getSocialLogInFormData(data, getState)),
    )
        .then((response) => {
            trackAppleLoginSuccess(state, response);

            return handleAppleLoginSuccess({
                state,
                data,
                response,
                dispatch,
            });
        })
        .then(() =>
            trackEventFromStateOnPageUnload(state, {
                action: GA_SOCIAL_LOGIN_EVENT,
                category: GA_AUTH_CATEGORY,
                label: socialProvider,
            }),
        )
        .catch(handleOnError(dispatch, state, data));
};

const trackAppleLoginSuccess = (state, response, actionCategory) => {
    if (response['new_user']) {
        trackEventFromState(state, {
            action: GA_APPLE_LOGIN_ACCOUNT_CREATED,
            category: actionCategory ? actionCategory : GA_AUTH_CATEGORY,
        });
    } else {
        trackEventFromState(state, {
            action: GA_APPLE_LOGIN_RETURNING_USER_LOGIN_SUCCESS,
            category: actionCategory ? actionCategory : GA_AUTH_CATEGORY,
        });
    }

    trackLoginSuccessful({
        sourceProvider: APPLE_PROVIDER,
        state,
    });
};

const handleAppleLoginSuccess = ({ state, response, data, dispatch }) => {
    // Fresh account coming from the social provider
    // Scenario: appleFreshAccount, appleFreshAccount_AddingExistingAccount, appleFreshAccount_AddingSoftAccount
    dispatch(setAccountExistent(data.email));
    dispatch(
        addSocialAuthenticationDataAction({
            socialAuthenticationData: { apple: data },
        }),
    );

    handleLoginSuccess({ state, response, dispatch });
};

/**
 * Returns a useful data structure for the socialLogin api
 * @param {bool} launchAuthenticationRefactor
 * @param {string} socialProvider
 * @param {object} data
 */
const getSocialLoginApiData = ({
    launchAuthenticationRefactor,
    socialProvider,
    data = {},
}) => {
    let _data = data;

    if (launchAuthenticationRefactor) {
        // On the new flow, data is the raw response we get from apple. On the old, it has already been parsed.
        const { accessToken, skipCreation, email, expirationTimestamp } = data;

        _data = {
            expirationTimestamp,
            email,
            accessToken,
            sourceProvider: socialProvider,
            skipCreation,
        };
    }

    return _data;
};
